import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Loader2 } from 'lucide-react';

export function ManageRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="cx-page flex items-center justify-center">
        <Loader2 className="h-7 w-7 animate-spin text-[color:var(--cx-primary)]" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  if (user.permission !== 'manage') {
    return <Navigate to="/" replace />;
  }
  return children;
}
